import {setup, run} from '../../snippets/php';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  'run-server': {
    Component: CreateShellCommand(run),
  },
};

export default ({
  keys,
  merchant,
  client,
  activePrice,
  checkoutMode,
  demo: {paymentMethods},
}) => `<?php

require 'vendor/autoload.php';
{+setup}
\\Stripe\\Stripe::setApiKey('${keys.secret}');
{/setup}

header('Content-Type: application/json');

$YOUR_DOMAIN = '${
  client === 'react'
    ? 'http://localhost:3000/checkout'
    : 'http://localhost:4242/public'
}';

{+create}
{span response create}$checkout_session{/span} = \\Stripe\\Checkout\\Session::create([
  {?customize prefill-email}
  'customer_email' => 'customer@example.com',
  {/prefill-email}
  {?customize submit-button}
  'submit_type' => 'donate',
  {/submit-button}
  {?customize address}
  'billing_address_collection' => 'required',
  'shipping_address_collection' => [
    'allowed_countries' => ['US', 'CA'],
  ],
  {/address}
  {+line-items}
  'line_items' => [[
    ${
      activePrice
        ? `'price' => '${activePrice.id}'`
        : `# TODO: replace this with the \`price\` of the product you want to sell
    'price' => '{{PRICE_ID}}'`
    },
    'quantity' => 1,
  ]],
  {/line-items}
  {+payment-methods}
  'payment_method_types' => [
    ${
      paymentMethods.length
        ? paymentMethods.map((key) => `'${key}',`).join('\n    ')
        : '# TODO: pass at least one option here'
    }
  ],
  {/payment-methods}
  {+mode}
  'mode' => '${checkoutMode}',
  {/mode}
  {+urls}
  'success_url' => $YOUR_DOMAIN . '${
    client === 'react' ? '?success=true' : '/success.html'
  }',
  'cancel_url' => $YOUR_DOMAIN . '${
    client === 'react' ? '?canceled=true' : '/cancel.html'
  }',
  {/urls}
  {?automatic-tax automatic-tax-param}
  'automatic_tax' => [
    'enabled' => true,
  ],
  {/automatic-tax-param}
]);

{+redirect}
header("HTTP/1.1 303 See Other");
header("Location: " . $checkout_session->url);
{/redirect}
{/create}`;
